import { render } from "./RoutesStatusTable.vue?vue&type=template&id=477cb1c2&scoped=true"
import script from "./RoutesStatusTable.vue?vue&type=script&lang=js"
export * from "./RoutesStatusTable.vue?vue&type=script&lang=js"

import "./RoutesStatusTable.vue?vue&type=style&index=0&id=477cb1c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477cb1c2"]])

export default __exports__